<template>
  <div class="Notice Notice--info is-loading">
    <h2 class="Notice-header">
      Your dashboard is being initialised.
    </h2>
    <p class="Notice-copy">
      Please wait a moment...
    </p>
  </div>
</template>

<script>

import { axios } from '../../bootstrap';
import LocaleCopy from '../../lang/en.json';

export default {
  props: {
    initDashboardUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  created() {
    axios.get(this.initDashboardUrl)
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        this.$_commonOperations_emitMessage(LocaleCopy.flashMessage.errors.initDashboard, 'error');
      });
  },
  methods: {
    emitMessage(text, type) {
      this.$bus.$emit('displayMsg', {
        text,
        type,
      });
    },
  },
};
</script>

<style scoped>
  .Notice {
    text-align: center;
    padding-bottom: 80px;
  }

  .is-loading::before {
    bottom: 20px;
    top: auto;
  }

  .is-loading::after {
    background: none;
  }
</style>
